
import React from 'react'
import Page from '../components/Page';
import { IonCard, IonCardHeader, IonButton, IonIcon } from '@ionic/react';
import { arrowForwardOutline } from 'ionicons/icons';

class Home extends React.Component {
  render() {
    return (
      <Page title="D2 Helper" large >
        <IonCard mode="ios" className="homecard" routerLink="/runewordsFinder">
          <IonCardHeader className="homecardcontent">
              <h1>Runeword Finder</h1>
              <p>Which ones can you make?</p>
              <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
                <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
              </div>
          </IonCardHeader>
        </IonCard>
        <IonCard mode="ios" className="homecard" routerLink="/runewords">
          <IonCardHeader className="homecardcontent">
            <h1>Browse Runewords</h1>
            <p>All of them</p>
            <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
              <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
            </div>
          </IonCardHeader>
        </IonCard>
        <IonCard mode="ios" className="homecard" routerLink="/runes">
          <IonCardHeader className="homecardcontent">
            <h1>Runes</h1>
            <p>And where to find them</p>
            <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
              <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
            </div>
          </IonCardHeader>
        </IonCard>
        <IonCard mode="ios" className="homecard" routerLink="/cuberecipes">
          <IonCardHeader className="homecardcontent">
            <h1>Horadric Cube</h1>
            <p>Recipes for cubing</p>
            <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
              <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
            </div>
          </IonCardHeader>
        </IonCard>
        <IonCard mode="ios" className="homecard" routerLink="/grail">
          <IonCardHeader className="homecardcontent">
            <h1>Holy Grail</h1>
            <p>Cross off items</p>
            <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
              <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
            </div>
          </IonCardHeader>
        </IonCard>
        <IonCard mode="ios" className="homecard" routerLink="/mule">
          <IonCardHeader className="homecardcontent">
            <h1>Mule</h1>
            <p>Track your mule inventories</p>
            <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
              <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
            </div>
          </IonCardHeader>
        </IonCard>
        <IonCard mode="ios" className="homecard" routerLink="/about">
          <IonCardHeader className="homecardcontent">
            <h1>About</h1>
            <p>Info &amp; privacy policy</p>
            <div style={{textAlign: 'right', position: 'absolute', right: 20, top: 38}}>
              <IonButton color="secondary"><IonIcon icon={arrowForwardOutline}/></IonButton>
            </div>
          </IonCardHeader>
        </IonCard>
      </Page>
    );
  }
}

export default Home
